export const environment = {
  BASE_URL: "https://ssp.posdigits.com/pos-api/api",
  BASE_URL2: "https://ssp.posdigits.com/pos-api/api",
}
